import React from 'react';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import SurveyStepFooter from 'Views/Onboarding/Pages/Survey/SurveyStep/SurveyStepFooter';
import useScrollTopOnMount from 'Hooks/useScrollTopOnMount';
import MetaControlField from 'Components/UI/Meta/MetaForm/Components/MetaControlField';
import AssetsAndLiabilitiesHeader
  from 'Views/Onboarding/Pages/Survey/SurveyStep/StepLibrary/AssetsAndLiabilitiesPartnerQuestion/AssetsAndLiabilitiesHeader';
import { FDBox, FDStack } from '@facet-wealth/design';

function AssetsAndLiabilitiesPartnerQuestionLayout() {
  useScrollTopOnMount();
  const {
    resource,
    onSubmit: onSubmitMetaForm,
  } = useMetaLayoutContext();

  return (
    <FDBox>
      <FDStack direction={'column'} spacing={4}>
        <AssetsAndLiabilitiesHeader resource={resource} />
        <FDBox paddingY={2}>
          <MetaControlField attr={'answer'} />
        </FDBox>
      </FDStack>
      <SurveyStepFooter
        onSubmit={onSubmitMetaForm}
      />
    </FDBox>
  );
}

AssetsAndLiabilitiesPartnerQuestionLayout.propTypes = {
};

AssetsAndLiabilitiesPartnerQuestionLayout.defaultProps = {
};

export default AssetsAndLiabilitiesPartnerQuestionLayout;
